const ROUTE_HOST_ENV = process.env.REACT_APP_ROUTE_ENV;

export const APP_CONFIG_DROPDOWN = ROUTE_HOST_ENV + 'esb/appconfig/configKeyList';
export const EVENTS_LOG = ROUTE_HOST_ENV + 'esb/event';
export const SYSTEM_EVENTS_LOG = ROUTE_HOST_ENV + 'esb/event/log';
export const LOGOUT = ROUTE_HOST_ENV + 'esb/member/logout';
export const REFRESH_TOKEN = ROUTE_HOST_ENV + 'esb/member/refresh/token';

/** Registration Endpoints start **/ 
export const VALIDATE_REGISTRATION = ROUTE_HOST_ENV + 'esb/memberregistration/validation';
export const REGISTRATION_OPTIONS = ROUTE_HOST_ENV + 'esb/claims/getValidOptions';
export const VALIDATE_REGISTRATION_OPTIONS = ROUTE_HOST_ENV + 'esb/memberregistration/emailcode';
export const VERIFY_VERIFICATION_CODE = ROUTE_HOST_ENV + 'esb/memberregistration/codeverify';
export const RESEND_VERIFICATION_CODE = ROUTE_HOST_ENV + 'esb/memberregistration/resendcode';
export const RESEND_EMAIL = ROUTE_HOST_ENV + 'esb/memberregistration/resendmail';
/** Registration Endpoints end **/ 

/** Member Profile Endpoints start **/
export const LOGIN_ADMIN = ROUTE_HOST_ENV + 'esb/member/loginAdmin';
export const LOGIN_USER = ROUTE_HOST_ENV + 'esb/member/login';
export const FORGOT_USERID = ROUTE_HOST_ENV + 'esb/member/forgotuserid';
export const GET_SECURITY_QS = ROUTE_HOST_ENV + 'esb/member/getSecQuestions';
export const PASSWORD_RECOVERY = ROUTE_HOST_ENV + 'esb/member/forgotPassword';
export const CHANGE_PASSWORD = ROUTE_HOST_ENV + 'esb/member/changePassword';
export const GENERATE_OTP = ROUTE_HOST_ENV + 'esb/member/generateOtp';
export const VALIDATE_OTP = ROUTE_HOST_ENV + 'esb/member/validateOtp';
export const LOCK_ACCOUNT = ROUTE_HOST_ENV + 'esb/member/lockAccount';
/** Member Profile Endpoints end **/

/** Claims Endpoints start **/
export const CLAIMS_ROLLING_MONTHS = ROUTE_HOST_ENV + 'esb/appconfig/listofmonths';
export const CLAIMS_MONTHLY_DATA = ROUTE_HOST_ENV + 'esb/claims/getMonthlyData';
export const CREATE_FEEDBACK = ROUTE_HOST_ENV + 'esb/claims/createFeedback';
export const UPDATE_FEEDBACK = ROUTE_HOST_ENV + 'esb/claims/updateFeedback';
/** Claims Endpoints end **/

/** Feedback Report Endpoints start **/
export const FEEDBACK_MONTHS = ROUTE_HOST_ENV + 'esb/claims/feedbackReport/listofmonths';
export const FEEDBACK_REPORT = ROUTE_HOST_ENV + 'esb/claims/feedbackReport';
/** Feedback Report Endpoints end **/
